import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const sendEmail = createAsyncThunk(
  "sendEmail",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/utils/send-email.php";
    const options = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
